import React, { PureComponent, DOM, PropTypes } from 'react';
import cx from 'classnames';
import { sessionNameWithDates } from '../filters/SessionFilters';
import FormControl from '../components/inputs/FormControl';
import { Button } from 'react-fast-ui';

const SESSION_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired
});

export default class SessionSelector extends PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    sessions: PropTypes.arrayOf(SESSION_SHAPE).isRequired,
    onChange: PropTypes.func.isRequired,
    value: SESSION_SHAPE,

    placeholder: PropTypes.string
  };

  static defaultProps = {
    value: null,
    disabled: false,
    placeholder: 'Select Session...'
  };

  handleSelect(session) {
    const { onChange } = this.props;
    onChange(session);
  }

  handleSelectId = ({ target: { value: id } }) => {
    this.handleSelect(_.findWhere(this.props.sessions, { id }));
  };

  handleClickPrev = () => {
    const { sessions, value } = this.props;

    const selectedIndex = _.indexOf(sessions, value);
    if (selectedIndex <= 0) {
      return;
    }

    this.handleSelect(sessions[ selectedIndex - 1 ]);
  };

  handleClickNext = () => {
    const { sessions, value } = this.props;

    const selectedIndex = _.indexOf(sessions, value);
    if (selectedIndex >= sessions.length - 1) {
      return;
    }

    this.handleSelect(sessions[ selectedIndex + 1 ]);
  };

  render() {
    const { disabled, value, sessions, placeholder, className } = this.props;
    const selectedIndex = _.indexOf(sessions, value);

    const showGender = _.chain(sessions).map(({ league: { gender } }) => gender).value().length > 1;

    return (
      <div className={cx('display-flex justify-content-center align-items-center', className)}>
        <Button
          borderless={true} icon="chevron-circle-left" type="primary" className="hidden-xs"
          disabled={disabled || selectedIndex === 0} inverse={true}
          onClick={this.handleClickPrev}
        />

        <div key="sessionName" className="mg-left-md mg-right-md">
          <FormControl>
            <select
              onChange={this.handleSelectId} value={value ? value.id : ''} placeholder={placeholder}
              disabled={disabled}
            >
              <option disabled hidden key="none" value="">{placeholder}</option>
              {
                sessions.map((session) => {
                  const { id, league: { gender } } = session;
                  return (
                    <option value={id} key={id}>
                      {sessionNameWithDates(session)} {showGender ? ` - ${gender}` : null}
                    </option>
                  );
                })
              }
            </select>
          </FormControl>
        </div>

        <Button
          borderless={true} icon="chevron-circle-right" type="primary" className="hidden-xs"
          disabled={disabled || selectedIndex >= sessions.length - 1} inverse={true}
          onClick={this.handleClickNext}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/SessionSelector.jsx